import React, { useEffect, useState } from 'react';
import { IHealthPlanMappingItem, IScenarioItem } from '../Infrastructure/Interfaces';
import useTable from '../TablePagination/UseTable';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Box,
  Input,
  Flex,
  useDisclosure,
  IconButton,
  Button,
  useToast,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogCloseButton,
  AlertDialogFooter,
  AlertDialogBody,
  AlertDialogHeader,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Link,
  Tooltip,
  Spacer,
  Select,
} from '@chakra-ui/react';
import TablePagination from '../TablePagination/TablePagination';
import { BsPencilSquare, BsThreeDotsVertical } from 'react-icons/bs';
import { AppDispatch } from '../Store/StoreInit';
import { useDispatch, useSelector } from 'react-redux';
import { FaMapSigns, FaRegCopy } from 'react-icons/fa';
import { fetchPayerMasterList } from '../Store/PayerMasterReducer';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import { ImBin } from 'react-icons/im';
import ScenariosModalPopup from './ScenariosModalPopup';
import {
  fetchFormDropdownList,
  fetchIdentifierInscoList,
  fetchOverridesList,
  setScenariosItem,
} from '../Store/ScenariosReducer';
import { HiDotsVertical } from 'react-icons/hi';
import IdentifiersModalPopup from './IdentifiersModalPopup';
import { HiMiniIdentification } from 'react-icons/hi2';
import PayerFormModalPoupup from './PayerFormModalPopup';
import { fetchSceneriosList } from '../Store/GetDropDownsValuesReducer';

interface Props {
  scenariosLists: IScenarioItem[];
  setTabIndex: any;
}

function ScenariosPg({ scenariosLists, setTabIndex }: Props) {
  const [value, setValue] = useState('');
  const [TableFilter, setTableFilter] = useState(scenariosLists);
  const [currentPage, setCurrentPage] = useState(1);
  const [claimsPerPage, setClaimsPerPage] = useState<number>(10);
  const lastIndex = currentPage * claimsPerPage;
  const firstIndex = lastIndex - claimsPerPage;
  const { slice, range } = useTable(
    value.length > 0 ? TableFilter : scenariosLists,
    currentPage,
    claimsPerPage
  );
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch<AppDispatch>();
  const [toBeDeletedItem, setToBeDeleteItem] = useState<IScenarioItem>();
  const {
    isOpen: isDeleteModalOpen,
    onOpen: onDeleteModalOpen,
    onClose: onDeleteModalClose,
  } = useDisclosure();
  const {
    isOpen: isIdentifierModalOpen,
    onOpen: onIdentifierModalOpen,
    onClose: onIdentifierModalClose,
  } = useDisclosure();
  const {
    isOpen: isPayerFormModalOpen,
    onOpen: onPayerFormModalOpen,
    onClose: onPayerFormModalClose,
  } = useDisclosure();
  const toast = useToast();
  const { accounts } = useMsal();
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '');
  const userid =
    userdetails[0].portal_Id != ''
      ? userdetails[0].portal_Id
      : accounts[0].username;
  const cancelRef = React.useRef(null);
  const [deleteOkLoading, setDeleteOkLoading] = useState(false);
  const userrole =
    userdetails[0]?.userRole != '' ? userdetails[0]?.userRole : 'User';
  const userAuthorized = process.env.REACT_APP_USER_ROLES as string;
  const splitauthorized = userAuthorized.split(',');
  const userAuthorizedFlag = splitauthorized.some(function (v) {
    return v === userrole;
  });
    const healthPlanMappingList: IHealthPlanMappingItem[] = useSelector(
    (state: any) => {
      return state.healthPlanPayerMappedList.healthPlanMappingList;
    }
  );
  const [scenarioMappedHealthPlanList, setScenarioMappedHealthPlanList] = useState<IHealthPlanMappingItem[]>([]);
  //let mappedPlanCount = 0
  const [mappedPlanCount, setMappedPlanCount] = useState(0);

  useEffect(() => {
    async function fetchData() {
      await dispatch(fetchIdentifierInscoList(scenariosLists[0]?.scenarioid));
    }
    fetchData();
    dispatch(fetchFormDropdownList());
  }, []);

  async function openPayerFormPg(id: number) {
    await dispatch(fetchOverridesList(id));
    var item: IScenarioItem = setScenarioItem(id);
    dispatch(setScenariosItem(item));
    onPayerFormModalOpen();
  }

  async function openIdentifierModal(id: number) {
    await dispatch(fetchIdentifierInscoList(id));
    var item: IScenarioItem = setScenarioItem(id);
    dispatch(setScenariosItem(item));
    onIdentifierModalOpen();
  }

  function deleteItemDialog(item: IScenarioItem) {
    const mappedPlan : IHealthPlanMappingItem[] = healthPlanMappingList.filter(x => x.scenarioId === item.scenarioid);
    setMappedPlanCount(mappedPlan ? mappedPlan.length : 0);
    setScenarioMappedHealthPlanList(mappedPlan ? mappedPlan : []);
    setToBeDeleteItem(item);
    onDeleteModalOpen();
  }

  async function deleteItem(item: IScenarioItem) {
    setDeleteOkLoading(true);
    const tokenurl = process.env.REACT_APP_SCENARIO_TOKEN_URL as string;
    const baseurl = process.env.REACT_APP_SERVER_SCENARIOS_BASE_URL as string;
    const url: string = `${baseurl}/Appeal/delete_scenario?scenarioid=${item.scenarioid}&user=${accounts[0].username}`;
    try {
      const res = await axios.get(tokenurl);
      if (res.data.success) {
        const response = await axios.post(url, null, {
          headers: {
            Pragma: 'no-cache',
            Authorization: `Bearer ${res.data.token}`,
          },
        });

        const getsistoken = await axios.get(process.env.REACT_APP_TOKEN_URL_SIS as string);

        if (response.data.success) {
          if (mappedPlanCount > 0) {
            for (const plan of scenarioMappedHealthPlanList) {
              const deleteUrl = `${process.env.REACT_APP_SERVER_BASE_URL}/Payer/delete_healthplanmapping?healthplanmappingid=${plan.healthPlanMappingId}`;
              await axios.delete(deleteUrl, {
                headers: {
                  Pragma: 'no-cache',
                  Authorization: `Bearer ${getsistoken.data.token}`,
                },
              });
            }
          }

          showToast('Success', `${item.name} deleted successfully`, 'success');
          onDeleteModalClose();
          //dispatch(fetchSceneriosList());
        }
      }
    } catch (error: any) {
      onDeleteModalClose();
    } finally {
      setDeleteOkLoading(false);
      dispatch(fetchSceneriosList());
    }
  }

  function showToast(
    title: string,
    description: string,
    status: 'error' | 'success'
  ) {
    toast({
      title,
      description,
      position: 'top',
      status,
      duration: status === 'error' ? 10000 : 5000,
      isClosable: true,
    });
  }

  function setScenarioItem(id: number) {
    var data = scenariosLists.find(item => item.scenarioid == id);

    let documentid: number = data?.documentid!;
    let variationId: number = data?.variationid!;
    let scenarioName: string = data?.name!;
    let billingSystem: string = data?.billing_system!;
    let billingClient: string = data?.billing_client!;
    let billingAdmin: string = data?.billing_admin!;
    let chartRequired: boolean = data?.chart_required!;
    let eobRequired: boolean = data?.eob_required!;
    let claimRequired: boolean = data?.claim_required!;
    let deliverOption: string = data?.deliver_option!;
    let deliverRegard: string = data?.deliver_regard!;
    let deliverToEmailAddress: string = data?.deliver_to_email_address!;
    let faxTo: string = data?.fax_to!;
    let faxToFaxNumber: string = data?.fax_to_faxnumber!;
    let faxUser: string = data?.fax_user!;
    let faxSecret: string = data?.fax_secret!;
    let requestorFirstName: string = data?.requestor_first_name!;
    let requestorLastName: string = data?.requestor_last_name!;
    let requestorPhone: string = data?.requestor_phone!;
    let requestorFax: string = data?.requestor_fax!;
    let requestorEmailAddress: string = data?.requestor_email_address!;
    let requestorSignature: string = data?.requestor_signature!;
    let requestorCompanyName: string = data?.requestor_company_name!;
    let requestorCompanyAddress1: string = data?.requestor_company_address1!;
    let requestorCompanyAddress2: string = data?.requestor_company_address2!;
    let requestorCompanyCity: string = data?.requestor_company_city!;
    let requestorCompanyState: string = data?.requestor_company_state!;
    let requestorCompanyZip: string = data?.requestor_company_zip!;
    let requestorAlternateContact: string = data?.requestor_alternate_contact!;
    let pageLimit: string = data?.page_limit!;
    let nextDelivery: string = data?.next_delivery!;
    let uploadChannel: string = data?.upload_channel!;
    let defaultChannel: boolean = data?.default_channel!;

    const item: IScenarioItem = {
      scenarioid: id,
      name: scenarioName,
      documentid: documentid,
      variationid: variationId,
      billing_system: billingSystem,
      billing_client: billingClient,
      billing_admin: billingAdmin,
      chart_required: chartRequired,
      eob_required: eobRequired,
      claim_required: claimRequired,
      deliver_option: deliverOption,
      deliver_regard: deliverRegard,
      deliver_to_email_address: deliverToEmailAddress,
      fax_to: faxTo,
      fax_to_faxnumber: faxToFaxNumber,
      fax_user: faxUser,
      fax_secret: faxSecret,
      requestor_first_name: requestorFirstName,
      requestor_last_name: requestorLastName,
      requestor_phone: requestorPhone,
      requestor_fax: requestorFax,
      requestor_email_address: requestorEmailAddress,
      requestor_signature: requestorSignature,
      requestor_company_name: requestorCompanyName,
      requestor_company_address1: requestorCompanyAddress1,
      requestor_company_address2: requestorCompanyAddress2,
      requestor_company_city: requestorCompanyCity,
      requestor_company_state: requestorCompanyState,
      requestor_company_zip: requestorCompanyZip,
      requestor_alternate_contact: requestorAlternateContact,
      page_limit: pageLimit,
      next_delivery: nextDelivery,
      upload_channel: uploadChannel,
      default_channel: defaultChannel,
    };

    return item;
  }

  function editItem(id: number) {
    var item: IScenarioItem = setScenarioItem(id);
    dispatch(setScenariosItem(item));
    onOpen();
  }

  function copyItem(id: number) {
    var item: IScenarioItem = setScenarioItem(id);
    item.scenarioid = 0;
    item.name = '';
    dispatch(setScenariosItem(item));
    onOpen();
  }

  const filterData = (e: any) => {
    if (e.target.value !== '') {
      setValue(e.target.value);
      const filterTable = scenariosLists.filter(o =>
        Object.keys(o).some(k =>
          String(o[k as keyof IScenarioItem])
            .toLowerCase()
            .includes(e.target.value.toLowerCase())
        )
      );
      setTableFilter([...filterTable]);
    } else {
      setValue(e.target.value);
    }
  };

  return (
    <>
      <Box display=" flex" flexDirection="column" onClick={setTabIndex(0)}>
        <Flex display="flex" justifyContent="flex-end" paddingBottom=".5rem">
          <Button
            bg="#002677"
            color="white"
            variant="outline"
            size="md"
            leftIcon={<FaMapSigns />}
            mr={4}
            onClick={() => editItem(0)}
          >
            Add New Scenario
          </Button>
          <Input
            htmlSize={24}
            width="auto"
            className="form-control"
            type="text"
            placeholder="Search table..."
            onChange={filterData}
            style={{ float: 'right', marginRight: '0.5rem' }}
          />
        </Flex>
        <TableContainer borderRadius="5px" borderTopColor="black" pl={1} pr={1}>
          <Table
            whiteSpace="break-spaces"
            variant="striped"
            colorScheme="blackAlpha"
            size="xs"
            overflow="Auto"
          >
            <Thead bgColor="#002677">
              <Tr>
                <Th fontSize="xs" color="white" pl={2}>
                  NAME
                </Th>
                <Th fontSize="xs" color="white">
                  BILLING SYSTEM
                </Th>
                <Th fontSize="xs" color="white">
                  BILLING CLIENT
                </Th>
                <Th fontSize="xs" color="white">
                  BILLING ADMIN
                </Th>
                <Th fontSize="xs" color="white">
                  DELIVERY OPTION
                </Th>
                <Th fontSize="xs" wordBreak="break-all" color="white">
                  DELIVERY MESSAGE
                </Th>
                <Th fontSize="xs" color="white">
                  DELIVERY EMAIL
                </Th>
                <Th fontSize="xs" color="white">
                  FAX TO
                </Th>
                <Th fontSize="xs" color="white">
                  FAX NUMBER
                </Th>
                <Th fontSize="xs" color="white">
                  NEXT DELIVERY
                </Th>
                {userAuthorizedFlag && (
                  <Th fontSize="xs" color="white">
                    ACTIONS
                  </Th>
                )}
              </Tr>
            </Thead>
            <Tbody>
              {(value.length > 0 ? TableFilter : scenariosLists)
                .slice(firstIndex, lastIndex)
                .map(item => {
                  return (
                    <Tr key={item.scenarioid} style={{ fontSize: '14px' }}>
                      <>
                        <Td whiteSpace="pre" pl={2}>
                          <Link
                            onClick={e => editItem(item.scenarioid)}
                            color="blue"
                          >
                            {item.name && (
                              <Tooltip
                                bg="#002677"
                                color="white"
                                label={item.name}
                                aria-label="name"
                                placement="left-start"
                                hasArrow
                                arrowSize={10}
                              >
                                {item.name.length > 25
                                  ? `${item.name.slice(0, 25)} ...`
                                  : item.name}
                              </Tooltip>
                            )}
                          </Link>
                        </Td>
                        <Td whiteSpace="pre">{item.billing_system}</Td>
                        <Td whiteSpace="pre">
                          {item.billing_client && (
                            <Tooltip
                              bg="#002677"
                              color="white"
                              label={item.billing_client}
                              aria-label="billing-client"
                              placement="left-start"
                              hasArrow
                              arrowSize={10}
                            >
                              {item.billing_client.length > 15
                                ? `${item.billing_client.slice(0, 15)} ...`
                                : item.billing_client}
                            </Tooltip>
                          )}
                        </Td>
                        <Td whiteSpace="pre">{item.billing_admin}</Td>
                        <Td whiteSpace="pre">{item.deliver_option}</Td>
                        <Td whiteSpace="pre">
                          {item.deliver_regard && (
                            <Tooltip
                              bg="#002677"
                              color="white"
                              label={item.deliver_regard}
                              aria-label="delivery-regard"
                              placement="left-start"
                              hasArrow
                              arrowSize={10}
                            >
                              {item.deliver_regard.length > 15
                                ? `${item.deliver_regard.slice(0, 15)} ...`
                                : item.deliver_regard}
                            </Tooltip>
                          )}
                        </Td>
                        <Td whiteSpace="pre">
                          {item.deliver_to_email_address}
                        </Td>
                        <Td whiteSpace="pre">
                          {' '}
                          {item.fax_to && (
                            <Tooltip
                              bg="#002677"
                              color="white"
                              label={item.fax_to}
                              aria-label="fax-to"
                              placement="left-start"
                              hasArrow
                              arrowSize={10}
                            >
                              {item.fax_to.length > 8
                                ? `${item.fax_to.slice(0, 8)} ...`
                                : item.fax_to}
                            </Tooltip>
                          )}
                        </Td>
                        <Td whiteSpace="pre">{item.fax_to_faxnumber}</Td>
                        <Td whiteSpace="pre">{item.next_delivery}</Td>
                        {userAuthorizedFlag && (
                          <Td pt="0" pb="0" mt="0" mb="0" pr="20px" isNumeric>
                            <Menu size="xs">
                              <MenuButton
                                size="xs"
                                as={IconButton}
                                aria-label="Options"
                                icon={<HiDotsVertical />}
                                background="none"
                              />
                              <MenuList>
                                <MenuItem
                                  icon={<BsPencilSquare />}
                                  onClick={e => editItem(item.scenarioid)}
                                >
                                  EDIT
                                </MenuItem>
                                <MenuItem
                                  icon={<FaRegCopy />}
                                  onClick={e => copyItem(item.scenarioid)}
                                >
                                  COPY
                                </MenuItem>
                                <MenuItem
                                  icon={<ImBin />}
                                  onClick={() => deleteItemDialog(item)}
                                >
                                  DELETE
                                </MenuItem>
                                <MenuItem
                                  icon={<HiMiniIdentification />}
                                  onClick={() =>
                                    openIdentifierModal(item.scenarioid)
                                  }
                                >
                                  IDENTIFIER
                                </MenuItem>
                                <MenuItem
                                  icon={<HiMiniIdentification />}
                                  onClick={() =>
                                    openPayerFormPg(item.scenarioid)
                                  }
                                >
                                  PAYER FORM
                                </MenuItem>
                              </MenuList>
                            </Menu>
                          </Td>
                        )}
                      </>
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
          <Flex display="flex" flexDirection="row">
            <Flex />
            <Spacer />
            <TablePagination
              range={range}
              slice={slice}
              setPage={setCurrentPage}
              page={currentPage}
            />
            <Spacer />
            <Select
              value={claimsPerPage}
              onChange={e => setClaimsPerPage(parseInt(e.target.value))}
              width="100px"
              height="30px"
              mt="5px"
              mr="5px"
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Select>
          </Flex>
        </TableContainer>
      </Box>
      <ScenariosModalPopup isOpen={isOpen} onOpen={onOpen} onClose={onClose} />
      <IdentifiersModalPopup
        isOpen={isIdentifierModalOpen}
        onOpen={onIdentifierModalOpen}
        onClose={onIdentifierModalClose}
      />
      <PayerFormModalPoupup
        isOpen={isPayerFormModalOpen}
        onOpen={onPayerFormModalOpen}
        onClose={onPayerFormModalClose}
      />
      <AlertDialog
        motionPreset="scale"
        isOpen={isDeleteModalOpen}
        leastDestructiveRef={cancelRef}
        onClose={onDeleteModalClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Scenario?
            </AlertDialogHeader>
            <AlertDialogCloseButton color="black" />
            <AlertDialogBody>
              Are you sure you want to delete <b>{toBeDeletedItem?.name}</b>{mappedPlanCount > 0 ? '. There are ' + mappedPlanCount + ' health plan(s) mapped with this scenario' : ''}?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                bg="#002677"
                color="white"
                onClick={onDeleteModalClose}
                ml={0}
              >
                Cancel
              </Button>
              <Spacer />
              <Button
                isLoading={deleteOkLoading}
                bg="#002677"
                color="white"
                ref={cancelRef}
                onClick={() => deleteItem(toBeDeletedItem!)}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}

export default ScenariosPg;
